'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * sns模块
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _i18n = require('../i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _util = require('../join/src/util');

var _util2 = require('../util');

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SNS = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(SNS, _React$PureComponent);

    function SNS(props) {
        (0, _classCallCheck3.default)(this, SNS);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SNS.__proto__ || Object.getPrototypeOf(SNS)).call(this, props));

        _this.defaultShow = 4;
        _this.ctrJoinList = [];
        _this.ctrLoginList = [];
        _this.sendCtr = false;

        _this.onShowAll = function () {
            var setSnsCtr = {};
            if (_this.props.tab === 'join') {
                setSnsCtr.isJoinShowAll = true;
            }
            if (_this.props.tab === 'login') {
                setSnsCtr.isLoginShowAll = true;
            }
            _this.setState(setSnsCtr, function () {
                _this.snsCtr(_this.props.tab);
            });
        };

        _this.onHide = function () {
            if (_this.props.tab === 'join') {
                _this.setState({
                    isJoinShowAll: false
                });
            }
            if (_this.props.tab === 'login') {
                _this.setState({
                    isLoginShowAll: false
                });
            }
        };

        _this.state = {
            loading: true,
            joinList: [],
            loginList: [],
            isJoinShowAll: false,
            isLoginShowAll: false
        };
        return _this;
    } // 默认显示个数

    // 已曝光注册SNS列表

    // 已曝光登录SNS列表

    (0, _createClass3.default)(SNS, [{
        key: 'renderSNSList',
        value: function renderSNSList(data, tab) {
            var _this2 = this;

            if (data && data.snsConfig) {
                var displayItemsForWeb = data.snsConfig.displayItemsForWeb; // eslint-disable-line
                // const url =  window.location.href;
                // 没有SNS渠道
                if (!displayItemsForWeb || displayItemsForWeb.length == 0) {
                    return;
                }
                // displayItemsForWeb.forEach((item) => {
                //     if (isMobile()) {
                //         item.requestUrl += '&from=msite';
                //     }
                //     item.requestUrl += `&return_url='${url}`;
                // });
                var snsList = { loading: false };
                if (tab === 'join') {
                    snsList.joinList = displayItemsForWeb;
                } else if (tab === 'login') {
                    snsList.loginList = displayItemsForWeb;
                }

                this.setState(snsList, function () {
                    if (!_this2.sendCtr) {
                        _this2.sendCtr = true;
                        _this2.snsCtr(tab);
                    }
                });
            } else {
                this.setState({
                    loading: true
                });
            }
        }
    }, {
        key: 'onSNSClick',
        value: function onSNSClick(data) {
            // 调用log4js.do记录日志，用来做服务端监控
            var url = '//m.aliexpress.com/ajaxapi/log4js.do';
            var logData = ['m_sns_login', 'sns_box', 'click', data.name, encodeURIComponent(data.requestUrl), +new Date()];
            url += '?log=' + logData.join(',') + ',';
            var n = 'logImage_' + +new Date() + '.r' + Math.floor(Math.random() * 1000); // eslint-disable-line
            var img = new Image();

            function onload() {
                window[n] = null;
            }
            img.onload = onload;
            window[n] = onload;
            img.onerror = onload;
            img.src = url;

            // 绑定点击打点
            if (this.props.tab === 'join') {
                (0, _util2.clickDot)({
                    objectType: 'button',
                    buttonType: 'register_sns',
                    objectValue: data.name
                });
            } else {
                (0, _util2.clickDot)({
                    objectType: 'button',
                    buttonType: 'sign_in_sns',
                    objectValue: data.name
                });
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.joinUiConfig && nextProps.joinUiConfig !== this.props.joinUiConfig) {
                this.renderSNSList(nextProps.joinUiConfig, 'join');
            }
            if (nextProps.loginUiConfig && nextProps.loginUiConfig !== this.props.loginUiConfig) {
                this.renderSNSList(nextProps.loginUiConfig, 'login');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var url = encodeURIComponent(this.props.snsReturnUrl);
            var joinList = this.state.isJoinShowAll ? this.state.joinList.slice(0) : this.state.joinList.slice(0, this.defaultShow);
            var loginList = this.state.isLoginShowAll ? this.state.loginList.slice(0) : this.state.loginList.slice(0, this.defaultShow);
            var snsReturnUrl = (0, _util.isMobile)() ? '&from=msite&return_url=' + url : '&return_url=' + url;
            return _react2.default.createElement(
                'section',
                { className: 'sns-login-wrap' },
                _react2.default.createElement(
                    'p',
                    { className: 'quick-access-title' },
                    _i18n2.default.QUICK_ACCESS
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sns-btns', onClick: this.on },
                    this.state.loading ? _react2.default.createElement(
                        'div',
                        { className: 'sns-loading' },
                        _react2.default.createElement('img', { src: '//aeis.alicdn.com/vip/havana-login/0.3.2/images/ajax-loader-16x16.gif' })
                    ) : _react2.default.createElement(
                        'div',
                        null,
                        this.props.tab === 'join' ? _react2.default.createElement(
                            'div',
                            { className: 'join-sns-wrap' },
                            joinList.map(function (item) {
                                return _react2.default.createElement(
                                    'div',
                                    { key: item.name, className: 'sns-item-wrap' },
                                    _react2.default.createElement('a', {
                                        className: 'sns-item ' + item.name,
                                        href: '' + item.requestUrl + snsReturnUrl,
                                        target: '_blank',
                                        onClick: function onClick() {
                                            _this3.onSNSClick(item);
                                        }
                                    })
                                );
                            })
                        ) : _react2.default.createElement(
                            'div',
                            { className: 'login-sns-wrap' },
                            loginList.map(function (item) {
                                return _react2.default.createElement(
                                    'div',
                                    { key: item.name, className: 'sns-item-wrap' },
                                    _react2.default.createElement('a', {
                                        className: 'sns-item ' + item.name,
                                        href: '' + item.requestUrl + snsReturnUrl,
                                        target: '_blank',
                                        onClick: function onClick() {
                                            _this3.onSNSClick(item);
                                        }
                                    })
                                );
                            })
                        )
                    )
                ),
                this.props.tab === 'join' ? _react2.default.createElement(
                    'p',
                    { className: 'trigger-wrap', style: { display: this.state.joinList.length > 4 ? 'block' : 'none' } },
                    this.state.isJoinShowAll ? _react2.default.createElement(
                        'a',
                        { className: 'hide', onClick: this.onHide },
                        _i18n2.default.HIDE
                    ) : _react2.default.createElement(
                        'a',
                        { className: 'show-all', onClick: this.onShowAll },
                        _i18n2.default.SHOW_ALL
                    )
                ) : null,
                this.props.tab === 'login' ? _react2.default.createElement(
                    'p',
                    { className: 'trigger-wrap', style: { display: this.state.loginList.length > 4 ? 'block' : 'none' } },
                    this.state.isLoginShowAll ? _react2.default.createElement(
                        'a',
                        { className: 'hide', onClick: this.onHide },
                        _i18n2.default.HIDE
                    ) : _react2.default.createElement(
                        'a',
                        { className: 'show-all', onClick: this.onShowAll },
                        _i18n2.default.SHOW_ALL
                    )
                ) : null
            );
        }

        // 发送SNSIcon的曝光打点

    }, {
        key: 'snsCtr',
        value: function snsCtr(tab) {
            var _this4 = this;

            var list = [];
            var dataList = [];
            if (tab === 'join') {
                dataList = this.state.isJoinShowAll ? this.state.joinList.slice(0) : this.state.joinList.slice(0, this.defaultShow);
                dataList.forEach(function (d) {
                    if (!_this4.ctrJoinList.includes(d.name)) {
                        list.push(d.name);
                        _this4.ctrJoinList.push(d.name);
                    }
                });
                if (!list.length) {
                    return;
                }
                (0, _util2.ctrDot)({
                    expPageArea: 'Register_SNS',
                    expType: 'register_sns',
                    expAttribute: list.join(',')
                });
            }
            if (tab === 'login') {
                dataList = this.state.isLoginShowAll ? this.state.loginList.slice(0) : this.state.loginList.slice(0, this.defaultShow);
                dataList.forEach(function (d) {
                    if (!_this4.ctrLoginList.includes(d.name)) {
                        list.push(d.name);
                        _this4.ctrLoginList.push(d.name);
                    }
                });
                if (!list.length) {
                    return;
                }
                (0, _util2.ctrDot)({
                    expPageArea: 'Signin_SNS',
                    expType: 'sign_in_sns',
                    expAttribute: list.join(',')
                });
            }
        }
    }]);
    return SNS;
}(_react2.default.PureComponent), _class.propTypes = {
    tab: _propTypes2.default.oneOf(['join', 'login']),
    loginUiConfig: _propTypes2.default.object,
    joinUiConfig: _propTypes2.default.object,
    snsReturnUrl: _propTypes2.default.string
}, _temp);
exports.default = SNS;